// extracted by mini-css-extract-plugin
export var aboveInput = "_mf-0";
export var actionButton = "_mf-5";
export var actionButtonContainer = "_mf-1";
export var actionIcon = "_mf-6";
export var aiInfoContainer = "_mf-2";
export var attachmentWrapper = "_mf-7";
export var bold = "_mf-3";
export var checkIcon = "_mf-8";
export var clickingRecipientBar = "_mf-11";
export var commentThreadSwitch = "_mf-a";
export var draftImage = "_mf-b";
export var draftImageContainer = "_mf-c";
export var draftImages = "_mf-e";
export var editButton = "_mf-g";
export var editor = "_mf-f";
export var editorContainer = "_mf-y";
export var editorErrorTooltipWrapper = "_mf-9";
export var headerDivider = "_mf-h";
export var icon = "_mf-i";
export var info = "_mf-j";
export var internal = "_mf-n";
export var internalDivider = "_mf-k";
export var internalMessage = "_mf-l";
export var messageInputCard = "_mf-m";
export var messageInputForm = "_mf-o";
export var messageInputFormInternal = "_mf-p";
export var options = "_mf-q";
export var publicMessageCustomer = "_mf-s";
export var publicMessageMerchant = "_mf-r";
export var removeImageButton = "_mf-d";
export var replyButtons = "_mf-t";
export var showSignatureButton = "_mf-u";
export var spinner = "_mf-v";
export var verticalButtonDivider = "_mf-4";
export var visibilitySelector = "_mf-w";
export var warning = "_mf-x";
export var wrappingText = "_mf-z";
export var writingInternalNoteTopBorder = "_mf-10";